<template>
    <div>
        <div class="font-Montserrat font-bold text-5xl text-center mb-[50px] ">{{ $t('AI-generated-photos') }}</div>
        <div class="flex items-center justify-center">
            <div v-for="item in picList1" :key="item.key" :value="item.key">
                <div class="flex flex-col items-center relative group mx-4">
                    <NuxtImg class="rounded-3xl " :src="item.url" width="280" height="420" :alt="item.name"
                        loading="lazy">
                    </NuxtImg>
                    <NuxtImg class="absolute top-1 opacity-0 group-hover:opacity-100 duration-150 w-full h-full p-4"
                        src="/assets/images/functype/allTools/newImgs/soildwhite.webp" width="248" height="388"
                        alt="white" loading="lazy">
                    </NuxtImg>
                    <a-upload image-preview ref="uploadRef" name="file" action="" @mousemove="move = true"
                        @mouseleave="move = false" @before-upload="(file) => onBeforeUpload(file, item)"
                        accept=" .bmp, .jpeg,.jpg,.png" :show-file-list="false"
                        class="absolute bottom-14 opacity-0 z-[2] h-[50px]">
                        <template #upload-button>
                            <a-button class="ml-[40px] mr-10" type="primary" @click="submit">
                                {{ $t('Generateit') }}</a-button>
                        </template>
                    </a-upload>
                    <button
                        class="absolute bottom-10 opacity-0 group-hover:opacity-100 group-hover:-translate-y-4 duration-200 py-4 bg-gradient-3 hover:bg-linear-gradient flex items-center justify-center text-white rounded-3xl">
                        <div class="ml-[40px]">
                            {{ $t('Generateit') }}
                        </div>
                        <div class="ml-4 mr-6" :class="{ 'arrow-move': move }">
                            <NuxtImg src="/assets/images/arrow1.svg" alt="arrow1" width="20" height="20"
                                loading="lazy" />
                        </div>
                    </button>
                </div>
            </div>

        </div>
        <div class="flex items-center justify-center mt-4">
            <div v-for="item in picList2" :key="item.key" :value="item.key">
                <div class="flex flex-col items-center relative group mx-4">
                    <NuxtImg class="rounded-3xl " :src="item.url" width="280" height="420" :alt="item.name"
                        loading="lazy">
                    </NuxtImg>
                    <NuxtImg class="absolute top-1 opacity-0 group-hover:opacity-100 duration-150 w-full h-full p-4"
                        src="/assets/images/functype/allTools/newImgs/soildwhite.webp" width="248" height="388"
                        alt="white" loading="lazy">
                    </NuxtImg>
                    <a-upload image-preview ref="uploadRef" name="file" action="" @mousemove="move = true"
                        @mouseleave="move = false" @before-upload="(file) => onBeforeUpload(file, item)"
                        accept=" .bmp, .jpeg,.jpg,.png" :show-file-list="false"
                        class="absolute bottom-14 opacity-0 z-[2] h-[50px]">
                        <template #upload-button>
                            <a-button class="ml-[40px] mr-10" type="primary" @click="submit">
                                {{ $t('Generateit') }}</a-button>
                        </template>
                    </a-upload>
                    <button
                        class="absolute bottom-10 opacity-0 group-hover:opacity-100 group-hover:-translate-y-4 duration-200 py-4 bg-gradient-3 hover:bg-linear-gradient flex items-center justify-center text-white rounded-3xl">
                        <div class="ml-[40px]">
                            {{ $t('Generateit') }}
                        </div>
                        <div class="ml-4 mr-6" :class="{ 'arrow-move': move }">
                            <NuxtImg src="/assets/images/arrow1.svg" alt="arrow1" width="20" height="20"
                                loading="lazy" />
                        </div>
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>
<script setup>
import { maxImageSize, imageAccept } from "@/utils/config";
const { t } = useI18n();
const localePath = useLocalePath();
const { uploadLocalFilesSuccessEvent } = useCustomEvent();
const move = ref(false)
const picList1 = ref([
    {
        key: 1, name: 'Portrait_1', url: '/assets/images/functype/allTools/newImgs/portrait-style-1.webp', params: 'hf'
    },
    {
        key: 2, name: 'Portrait_2', url: '/assets/images/functype/allTools/newImgs/portrait-style-2.webp', params: 'dhsh'
    },
    {
        key: 3, name: 'Portrait_3', url: '/assets/images/functype/allTools/newImgs/portrait-style-3.webp', params: 'doll'
    },
    {
        key: 4, name: 'Portrait_4', url: '/assets/images/functype/allTools/newImgs/portrait-style-4.webp', params: 'ova'
    }
])
const picList2 = ref([
    {
        key: 5, name: 'Portrait_5', url: '/assets/images/functype/allTools/newImgs/portrait-style-5.webp', params: 'ljgc'
    },
    {
        key: 6, name: 'Portrait_6', url: '/assets/images/functype/allTools/newImgs/portrait-style-6.webp', params: 'repin'
    },
    {
        key: 7, name: 'Portrait_7', url: '/assets/images/functype/allTools/newImgs/portrait-style-7.webp', params: 'manga'
    },
    {
        key: 8, name: 'Portrait_8', url: '/assets/images/functype/allTools/newImgs/portrait-style-8.webp', params: 'egypt'
    }
])
const formatFailFiles = ref([]);
const fileList = ref([]);
const timeout = ref();
const sizeFailFiles = ref([]);
const { isLogin, isVip, isVipPro, checkWeekCount } = useUserInfo()
function debounce(fun, time = 500) {
    if (timeout.value) {
        clearTimeout(timeout.value); // 规定时间内若定时器存在则清除
    }
    timeout.value = setTimeout(() => {
        fun(); // 调用接口
        clearTimeout(timeout.value);
    }, time);
}
function onBeforeUpload(file, record) {
    const suffix = getFileSuffix(file.name).toLowerCase();
    fileList.value = []
    if (imageAccept.includes(suffix)) {
        if (file.size < maxImageSize) {
            fileList.value.push(file);
        } else {
            sizeFailFiles.value.push(file);
        }
    } else {
        formatFailFiles.value.push(file);
    }
    debounce(() => {
        if (fileList.value.length > 1) {
            if (isVipPro.value) {
                messageBox.error(t("index-upload"), t("index-upload-limit"));
            } else {
                messageBox.error(
                    t("index-upload-batch"),
                    t("index-upload-batch-limit")
                );
            }
            return;
        }
        imageHandle(record);
    });
    return false;
}
function imageHandle(record) {
    if (formatFailFiles.value.length > 0) {
        messageBox.error(
            t("index-upload"),
            t("index-upload-limit-format", { format: imageAccept.join("、") })
        );
        formatFailFiles.value = [];
        fileList.value = [];
        sizeFailFiles.value = [];
        return;
    } else if (sizeFailFiles.value.length > 0) {
        messageBox.error(t("index-upload"), t("index-upload-limit-size"));
        formatFailFiles.value = [];
        fileList.value = [];
        sizeFailFiles.value = [];
        return;
    } else if (fileList.value.length > 1) {
        messageBox.error(t("index-upload"), t("index-upload-limit"));
        formatFailFiles.value = [];
        fileList.value = [];
        sizeFailFiles.value = [];
        return;
    }
    onSuccess(fileList.value, record);
}

function onSuccess(fileList, record) {
    fileList[0].query = record.params;
    uploadLocalFilesSuccessEvent(fileList)
}
</script>
<style scoped></style>